import { Component, OnInit, ChangeDetectorRef, ApplicationRef, ViewChild} from '@angular/core';
import { BaseService } from '../../../services/base.services';
import {NgbDate, NgbCalendar, NgbDateParserFormatter, NgbTabsetConfig} from '@ng-bootstrap/ng-bootstrap';
import pageSettings from '../../../config/page-settings';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { formatDate} from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material';
import { DaterangepickerComponent, DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { NgxChartsModule, id } from '@swimlane/ngx-charts';
import * as moment from 'moment';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import 'nvd3';
declare var Highcharts: any;
declare var nv: any;


import * as global from '../../../config/globals';
@Component({
  selector: 'production',
  templateUrl: './production.html',
  styleUrls: ['production.css']
})

export class ProductionPage implements OnInit{
  private data:Array<any> = [];
  pageSettings = pageSettings;
  cargando = false;
  tareas: any = [];
  tareaSeleccionada: any;
  loading = false;
  equipos: any = [];
  listNiveles: any= [];
  menuMobile: any = [
    {
      Id: 1,
      Nombre: 'Home',
      Icono: 'fa-home',
      Href: '/gestionTareas',
    },
    {
      Id: 2,
      Nombre: 'Mantención',
      Icono: 'fa-cogs',
      Href: '/mantenciones',
    },
    {
      Id: 3,
      Nombre: 'Producción',
      Icono: 'fa-chart-bar',
      Href: '/produccion',
    },
    {
      Id: 4,
      Nombre: 'Actividades',
      Icono: 'fa-list-alt',
      Href: '/actividades',
    },
    {
      Id: 5,
      Nombre: 'Estandares',
      Icono: 'fa-server',
      Href: '/estandares',
    },    
  ]
  menuSelected: any = 3;
  turno;
  public constructor(
    private baseService: BaseService,
    private calendar: NgbCalendar, 
    public formatter: NgbDateParserFormatter,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private cd : ChangeDetectorRef,
    private route: ActivatedRoute,
    private appRef: ApplicationRef,
    private config: NgbTabsetConfig
    ) {
        this.pageSettings.pageEmpty = false;
        this.pageSettings.pageWithoutSidebar = true;
        this.pageSettings.appSelected = null;
        config.justify = 'center';
        registerLocaleData( es );

  }

  async ngOnInit()  {
    this.tareas = [
    { 'Icono': 'fa-plus', 'href':'/gestionTareas', 'Descripcion': 'Realicé mi encuesta COVID', 'checked': true },
    { 'Icono': 'fa-edit', 'href':'/gestionTareas', 'Descripcion': 'Realicé mi ART.' },
    { 'Icono': 'fa-cogs', 'href':'/gestionTareas', 'Descripcion': 'Mantenciones.' },
    { 'Icono': 'fa-chart-bar', 'href':'/gestionTareas', 'Descripcion': 'Plan Producción.' },
    { 'Icono': 'fa-list-alt', 'href':'/gestionTareas', 'Descripcion': 'Actividades.' },
    { 'Icono': 'fa-server', 'href':'/gestionTareas', 'Descripcion': 'Revisar Estándares.' },
    ];

     this.GetReporteFlash1();
     this.GetCajasDiagramaOE();
     this.get_Turno();
  }

  checkTodoList(item) {
    if (item.checked) {
      item.checked = false;
    } else {
      item.checked = true;
    }
  };

  async GetReporteFlash1(){
    try{
      this.cargando = true;
      this.equipos = await this.baseService.GetReporteFlash1({idEquipo: 0, ultimo:1, frecuencia: 5, horas: 24, seccion:7}).toPromise();
      this.cargando = false;
      this.get_Comentarios();
    }catch(error){
      this.cargando = false;
      console.log(error);
    }
  }

  async get_Comentarios(){
    try{
      this.cargando = true;
      var comentarios: any = await this.baseService.get_Comentarios({IdEquipo: 0, IdTipo: 0}).toPromise();
      this.equipos.forEach(e => {
        comentarios.forEach(c => {
          if(c.idEquipo == e.idEquipo){
            e.comentario = c.Comentario;
          }
        });
      });
      this.cargando = false;
    }catch(error){
      this.cargando = false;
      console.log(error);
    }
  }

  async add_ProdLog(item) {
    try {
      if(!item.comentario){
        this.toastr.error('Debe ingresar un comentario', 'No guardado');
        return;
      }
      console.log(item);
      var _storage = JSON.parse(localStorage.getItem('data'));
      console.log(_storage.usuario.IDUSUARIO);
      var respuesta = await this.baseService.add_ProdLog({IdEquipo: item.idEquipo, Fecha: item.fecha, 
        IdUsuario: _storage.usuario.IDUSUARIO, 
        Comentario: item.comentario, Proy: item.proy, Meta: '', Rend: item.rend}).toPromise();
     console.log(respuesta);
      this.toastr.success('Comentario guardado', '');
      item.agregarComentario = false;
    }catch(error){
      console.log(error);
    }
  }

  doTextareaValueChange(ev) {
    try {
      this.tareaSeleccionada.motivo = ev.target.value;
    } catch(e) {
    }
  }

  async get_Turno(){
    try{
      var turno = await this.baseService.get_Turno({}).toPromise();
      this.turno = turno;
    }catch(error){
      console.log(error);
    }
  }
  
  modalCancelar(modal, tarea){
    this.tareaSeleccionada = tarea;
    this.modalService.open(modal, { size: 'lg' }) 
  }

  async GetCajasDiagramaOE(){
    try{
      this.cargando = true;
      var response: any = await this.baseService.GetCajasDiagramaOE({
        horas: 24, min: 15, ultimo:1, idAtt:0, idActivo:0, medicion:'niveles', seccion: 9
      }).toPromise();

    response.map(x=> x.Ton = parseInt(x.Ton.toFixed(0)));
    this.listNiveles = response;
    this.cargando = false;

    }catch(error){
      this.cargando = false;
      console.log(error);
    }
  }

}
